import ConfirmDeleteDialog from "./delete"
import ExportProjectDialog from "./export-project"
import ExportSchemesDialog from "./export-schemes"
import ImportProjectDialog from "./import-project"
import NewContentBlockDialog from "./new-content-block"
import NewSiteDialog from "./new-site"
import SchemaSettings from "./schema-settings"

const dialogs = {
  newContentBlock: NewContentBlockDialog,
  newSite: NewSiteDialog,
  delete: ConfirmDeleteDialog,
  exportProject: ExportProjectDialog,
  importProject: ImportProjectDialog,
  exportSchemes: ExportSchemesDialog,
  schemaSettings: SchemaSettings
}

export default dialogs

export const customDialogs: (keyof typeof dialogs)[] = [ ]
